import { takeshotRegAction, showSnaphotCount } from "../snapshot/snapshotSlice";
import {
  countDown,
  setCounterIntervalId,
  setRandomize,
} from "../timer/timerSlice";
import { generateRandom } from "../../../utils/utils";
import { longSoundCounting } from "../audioDetection/audioSlice";
import { multiFaceCounter } from "../warning/warningSlice";
import {
  // routineCheckSave,
  updateExamActivities,
} from "../../activityAsyncAction";

export const counterUpdater = () => {
  return (dispatch, getState) => {
    let {
      timer: { times },
      snapshot: { numberOfSnapShots },
    } = getState();
    const maxSnapshotTime = times.expiryTime / (numberOfSnapShots * 1000);
    let totalCount = 0;
    let now = Math.floor(Date.now() / 1000);
    const calcMinTime = () =>
      now + Math.floor(maxSnapshotTime / numberOfSnapShots);
    let minTime = calcMinTime();
    let maxTime = now + maxSnapshotTime;
    let randomized = Math.floor(generateRandom(minTime, maxTime));
    dispatch(setRandomize(randomized));
    console.log("this is my randomized", randomized);
    let timerInterval = setInterval(() => {
      const {
        timer: {
          examStarted,
          examEnded,
          timeCount,
          randomize,
          counterIntervalId,
        },
        examDetail: { submitted, examPlan },
      } = getState();
      console.log("this is the radomize value", randomize);
      if (examEnded || submitted) {
        clearInterval(counterIntervalId);
        return;
      }
      if (examStarted) {
        totalCount = totalCount + 1;
        // console.log(totalCount);
        // console.log(randomized);

        if (!(examPlan === "basic")) {
          if (totalCount + now === randomized - 4) {
            dispatch(showSnaphotCount());
            console.log("the dispatch is called");
          }
          if (totalCount + now === randomized) {
            dispatch(takeshotRegAction());
            console.log("the dispatch is called");
          }
          if (totalCount >= maxSnapshotTime) {
            totalCount = 0;
            now = Math.floor(Date.now() / 1000);
            minTime = calcMinTime();
            maxTime = now + maxSnapshotTime;
            randomized = Math.floor(generateRandom(minTime, maxTime));
          }
        }

        dispatch(countDown());
        dispatch(longSoundCounting());
        dispatch(multiFaceCounter());
        if (!(timeCount % 60)) {
          dispatch(updateExamActivities());
        }
        // if (!(timeCount % 20)) {
        //   dispatch(routineCheckSave());
        // }
      }
    }, 1000);
    dispatch(setCounterIntervalId(timerInterval));
  };
};
